import $ from "jquery";

class CookiesConsent {
	constructor(lang = null) {
		this.cookiesLinks = document.querySelectorAll('.cookie-link');
        this.supportedTaCLanguages = ['fr', 'en', 'de', 'es', 'it', 'pt', 'pl', 'ru'];
        
        if(lang && this.supportedTaCLanguages.indexOf(lang) !== -1) {
            // Set TaC language
    		this._setLang(lang);
        }
        this._events();
        // Initialize TaC
		this._init();
        // Set TaC jobs for each service
		this._setJobs();

        // Bind links to open TaC panel another time after cookies acceptance
		if(this.cookiesLinks.length) {
			this._bindCookiesLinks();
		}
	}

	_init() {
		tarteaucitron.init({
            "privacyUrl": "", /* Privacy policy url */
            "hashtag": "#tarteaucitron", /* Open the panel with this hashtag */
            "cookieName": "tarteaucitron", /* Cookie name */
            "orientation": "bottom", /* Banner position (top - bottom) */
            "groupServices": true, /* Group services by category */
            "showAlertSmall": false, /* Show the small banner on bottom right */
            "cookieslist": false, /* Show the cookie list */
            "closePopup": false, /* Show a close X on the banner */
            "showIcon": false, /* Show cookie icon to manage cookies */
            //"iconSrc": "", /* Optionnal: URL or base64 encoded image */
            "iconPosition": "BottomRight", /* BottomRight, BottomLeft, TopRight and TopLeft */
            "adblocker": false, /* Show a Warning if an adblocker is detected */
            "DenyAllCta" : true, /* Show the deny all button */
            "AcceptAllCta" : true, /* Show the accept all button when highPrivacy on */
            "highPrivacy": true, /* HIGHLY RECOMMANDED Disable auto consent */
            "handleBrowserDNTRequest": false, /* If Do Not Track == 1, disallow all */
            "removeCredit": true, /* Remove credit link */
            "moreInfoLink": true, /* Show more info link */
            "useExternalCss": true, /* If false, the tarteaucitron.css file will be loaded */
            "useExternalJs": false, /* If false, the tarteaucitron.js file will be loaded */
            //"cookieDomain": ".my-multisite-domaine.fr", /* Shared cookie for multisite */
            "readmoreLink": "", /* Change the default readmore link */
            "mandatory": true /* Show a message about mandatory cookies */
        });
	}

    _events() {
        tarteaucitron.events.load = function() {
            setTimeout(function() {
                const allAllowedButton = document.getElementById('tarteaucitronAllAllowed');
                if(allAllowedButton) {
                    const buttonValidateSettingsButton = document.createElement('button');
                    buttonValidateSettingsButton.id ='tarteaucitronValidateSettings';
                    buttonValidateSettingsButton.textContent = 'Sauvegarder';
                    allAllowedButton.parentNode.insertBefore(buttonValidateSettingsButton, allAllowedButton);
        
                    buttonValidateSettingsButton.addEventListener('click', function(e) {
                        e.preventDefault();
                        tarteaucitron.userInterface.closePanel();
                        tarteaucitron.userInterface.closeAlert();
                    });
                }
            });
        }
    }

	_bindCookiesLinks() {
        this.cookiesLinks.forEach(function(link) {
            link.addEventListener('click', tarteaucitron.userInterface.openPanel, false);
        });
	}

	_setLang(lang) {
		window.tarteaucitronForceLanguage = lang;
	}

	_setJobs() {
        if(document.location.host === 'escalocean.fr') {
    		// Add Google Analytics job
    		tarteaucitron.user.gtagUa = "G-75MRQKXFKE";
    		tarteaucitron.user.gtagMore = function () {};
    		(tarteaucitron.job = tarteaucitron.job || []).push("gtag");
        }
	}
}

export default CookiesConsent;
